import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, ArrowRightIcon } from 'lucide-react';
export function LimitedEditionBanner() {
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="bg-ink text-cream py-3 px-4 relative z-50 border-b border-white/10" data-id="element-76">
      <a href="#offer" className="max-w-7xl mx-auto flex items-center justify-center text-sm sm:text-base font-medium group cursor-pointer" data-id="element-77">
        <span className="flex items-center justify-center bg-leaf/20 text-leaf rounded-full p-1 mr-3" data-id="element-78">
          <SparklesIcon className="w-3.5 h-3.5" data-id="element-79" />
        </span>
        <span className="truncate" data-id="element-80">
          <strong className="text-white font-bold tracking-wide uppercase text-xs sm:text-sm mr-2" data-id="element-81">
            Edición Limitada
          </strong>
          <span className="opacity-90 hidden sm:inline" data-id="element-82">
            Obtén el manual completo + bonus exclusivos hoy.
          </span>
        </span>
        <span className="ml-3 sm:ml-4 flex items-center text-leaf font-bold group-hover:text-white transition-colors duration-300 whitespace-nowrap" data-id="element-83">
          Ver oferta{' '}
          <ArrowRightIcon className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-84" />
        </span>
      </a>
    </motion.div>;
}